import React, { Fragment } from "react";
import { Col } from "react-bootstrap";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import face01 from "../../assets/rostros/face01.png";
import face02 from "../../assets/rostros/face02.png";
import face03 from "../../assets/rostros/face03.png";
import face04 from "../../assets/rostros/face04.png";
import face05 from "../../assets/rostros/face05.png";
import face06 from "../../assets/rostros/face06.png";
import face07 from "../../assets/rostros/face07.png";
import face08 from "../../assets/rostros/face08.png";

const RazonUno = () => {
  return (
    <Fragment>
      <Col lg={6}>
        <h4>Razón #1</h4>
        <h2
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Miles de clientes satisfechos
        </h2>
        <h1
          data-aos="fade-right"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
            {({ isVisible }) => (
              <div style={{ height: 100 }}>
                {isVisible ? (
                  <CountUp
                    start={0}
                    end={45000}
                    duration={1}
                    separator="."
                    prefix="+"
                    delay={0}
                  ></CountUp>
                ) : null}
              </div>
            )}
          </VisibilitySensor>
        </h1>
        <p
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Hogares felices, disfrutando del mejor producto del mercado. Somos la
          marca más recomendada.
        </p>
      </Col>
      <Col lg={6}>
        <img
          src={face01}
          className="faces face01"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face02}
          className="faces face02"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face03}
          className="faces face03"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face04}
          className="faces face04"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face05}
          className="faces face05"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face06}
          className="faces face06"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face07}
          className="faces face07"
          alt="Miles de clientes satisfechos."
        ></img>
        <img
          src={face08}
          className="faces face08"
          alt="Miles de clientes satisfechos."
        ></img>
      </Col>
    </Fragment>
  );
};

export default RazonUno;
